module.exports = __webpack_public_path__ + "img/large-orange-diamond.80daa5c6.png";